export default __webpack_public_path__ + "static/media/bing_aerial.53d07137.png";